export enum EstatusOfferEnum{
    Creada=1,
    Aprobada=2,
    Rechazada=3
}